import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { CAMPAIGN_TYPES_VALUES } from 'containers/AwarenessCenter/constants'

import { CHANGE_SPEAR_PHISHING_CAMPAIGN_DATA } from '../../WizardSpearPhishingCampaign/constants'
import { selectCampaignId } from '../selectors'

import {
  getEmailsError,
  getEmailsSuccess,
  getLandingDomainListError,
  getLandingDomainListSuccess,
  retrieveEmailError,
  retrieveEmailSuccess,
  spearPhishingCampaignDataPollingError,
  spearPhishingCampaignDataPollingSuccess,
  updateEmailError,
  updateEmailSuccess,
  updateParticipantsError,
  updateParticipantsSuccess,
} from './actions'
import {
  GET_EMAILS,
  GET_LANDING_DOMAIN_LIST,
  RETRIEVE_EMAIL,
  SPEAR_PHISHING_CAMPAIGN_DATA_POLLING,
  UPDATE_EMAIL,
  UPDATE_PARTICIPANTS,
} from './constants'
import { selectCreatedSpearPhishingCampaignId } from './selectors'

const getEmailsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      GET_EMAILS.INITIATE,
      UPDATE_PARTICIPANTS.INITIATE,
      SPEAR_PHISHING_CAMPAIGN_DATA_POLLING.SUCCESS
    )
    .mergeMap((action) =>
      api.wizardCampaign
        .getEmails(
          store.getState().partnerOptions.selectedCompany?.value,
          selectCampaignId(store.getState()) ||
            selectCreatedSpearPhishingCampaignId(store.getState())
        )
        .map((response) => {
          if (action.type === GET_EMAILS.INITIATE) return getEmailsSuccess(response)
          return updateParticipantsSuccess(response)
        })
        .catch((error) =>
          Observable.of(
            epicsErrorHandler(
              action.type === GET_EMAILS.INITIATE ? getEmailsError : updateParticipantsError,
              error,
              [400]
            )
          )
        )
        .takeUntil(action$.ofType(GET_EMAILS.CANCEL, UPDATE_PARTICIPANTS.CANCEL))
    )

const updateEmailEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_EMAIL.INITIATE).mergeMap((action) =>
    api.wizardCampaign
      .updateEmail(
        action.payload.scenarioId,
        action.payload.data,
        store.getState().partnerOptions.selectedCompany?.value
      )
      .map((ajaxResponse) => updateEmailSuccess(ajaxResponse.response))
      .catch((error) => Observable.of(epicsErrorHandler(updateEmailError, error, [400])))
  )

const retrieveEmailEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(RETRIEVE_EMAIL.INITIATE).mergeMap((action) =>
    api.wizardCampaign
      .retrieveEmail(
        action.payload.scenarioId,
        store.getState().partnerOptions.selectedCompany?.value
      )
      .map((response) => retrieveEmailSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(retrieveEmailError, error, [400])))
      .takeUntil(action$.ofType(RETRIEVE_EMAIL.CANCEL))
  )

const getDomainLandingEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(GET_LANDING_DOMAIN_LIST.INITIATE).mergeMap(() =>
    api.awarenessCenter
      .details(
        store.getState().partnerOptions.selectedCompany?.value,
        !!store.getState().app.data.partner,
        CAMPAIGN_TYPES_VALUES.SPEAR_PHISHING
      )
      .map((response) => getLandingDomainListSuccess(response.landingDomainList))
      .catch((error) => Observable.of(epicsErrorHandler(getLandingDomainListError, error, [400])))
      .takeUntil(action$.ofType(GET_LANDING_DOMAIN_LIST.CANCEL))
  )

const spearPhishingCampaignDataPollingEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(SPEAR_PHISHING_CAMPAIGN_DATA_POLLING.INITIATE)
    .filter(() => {
      if (store.getState().awarenessCenter.wizardSpearPhishingCampaign) return true
      return false
    })
    .mergeMap((action) =>
      api.wizardCampaign
        .getCampaign(
          store.getState().partnerOptions.selectedCompany?.value,
          selectCampaignId(store.getState()) || action.payload.campaignId
        )
        .mergeMap((response) => Observable.of(spearPhishingCampaignDataPollingSuccess(response)))
        .catch((error) =>
          Observable.of(epicsErrorHandler(spearPhishingCampaignDataPollingError, error))
        )
        .takeUntil(
          action$.ofType(
            SPEAR_PHISHING_CAMPAIGN_DATA_POLLING.CANCEL,
            CHANGE_SPEAR_PHISHING_CAMPAIGN_DATA
          )
        )
    )

export default combineEpics(
  getEmailsEpic,
  getDomainLandingEpic,
  updateEmailEpic,
  retrieveEmailEpic,
  spearPhishingCampaignDataPollingEpic
)
